import { child, set, onValue, update, remove, getDatabase , ref as refDb,} from 'firebase/database';
import { PiniaPluginContext } from 'pinia'
import { usePosStore } from '../stores/pos';
import { useEmployeePinStore } from '~/modules/setting/stores/employeePin';
import { useServerTime } from '~/modules/core/utils/timestamp';
import {  updateDoc, setDoc, onSnapshot } from "firebase/firestore";
import { FIRESTORE_COLLECTIONS } from "~~/interface/FirestoreCollections";
import _ from "lodash"

import dayjs from 'dayjs';
const DELAY_TIME = 3 
let isListenerStarted = false

function MyPiniaPlugin({ store }: PiniaPluginContext) {  
  return 
  if(isListenerStarted){
    return
  }

  isListenerStarted = true
  const delay = (callback, seconds) =>  setTimeout(()=>callback(), 1000 * seconds);
    
  //WAIT STORES REGISTER WITH DELAY 3 SEC
    delay(() => {
      onValueWithNonceTrigger(() => {        
        const jobStore = useJobsStore();
        const tables = jobStore.tables;
        const tableV2 = jobStore.tables_v2;
        const posStore = usePosStore();
        const tableState = posStore.tableState;        
        
        const tableMetaResult = calculateTableMeta(tables, tableV2)
        const summary = computeSummary(tables, jobStore.jobs, jobStore.paidAmount)

        updateTableMetaToFirestore(tableMetaResult)
        updateLiveToFirestore(summary)
        updateTableStateToFirestore(tableState)
        resetNonce()
      });

    }, DELAY_TIME)
}  



function onValueWithNonceTrigger(callback){
  const firestoreDb = useFirebaseFirestore();
  const versionDataRef = firestoreDb.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.SYNC_DATA,FIRESTORE_COLLECTIONS.VERSION_DATA)

  onSnapshot(versionDataRef, (doc) => {
    const versionData = doc.data()
    if (!versionData || versionData.nonce === 1) return;

    callback() 
  })
}

function calculateTableMeta(tables, tableV2){
  const tableData = tables // start date, end date, items
      const tableCalculated = tableV2 // money summary , rounding
      // todo get the state table eg. lock or not

      let _res = {}

      //* combine the data and calculated
      _.forEach(tableData, (table, index) => {
        
        const { subTotal, dc1, sc, dc2, cc, tax, rounding, grandTotal } = tableCalculated[index];
    
        _res[index] = {
          guests: table.guests, 
          startDate:table.startDate,
          subTotal: subTotal,
          dc1: dc1,
          sc: sc,
          dc2: dc2,
          cc:cc,
          tax: tax,
          rounding: rounding,
          grandTotal: grandTotal,
          itemsLength: table.items.length,
        }
      })

      return _res
}

function computeSummary(data: {}, jobs: any[], grandTotal: number) {

   const lastJob = jobs[jobs.length - 1];
   const lastupdate = lastJob?.timestamp || Date.now();  

   let summary = {
     totalTables: 0,
     totalGuests: 0,
     totalAmount: 0,
     lastupdate,
     grandTotal,
     jobCountItems:jobs.length
   };
   _.forEach(data, (table: any) => {

     let amount = _.sumBy(table.items, 'amount')
     summary.totalTables += 1
     summary.totalGuests += table.guests || 0
     summary.totalAmount += amount
     
   })

   return summary;

 }


 function updateTableStateToFirestore(tableState){
  const firestoreDb = useFirebaseFirestore();
  let tableStateRef = firestoreDb.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.SYNC_DATA,FIRESTORE_COLLECTIONS.TABLE_STATE)  
  return setDoc(tableStateRef, tableState, {merge: true});
}

function updateTableMetaToFirestore(tableMetaData){
  const firestoreDb = useFirebaseFirestore();
  let tableMetaRef = firestoreDb.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.SYNC_DATA,FIRESTORE_COLLECTIONS.TABLE_META)  
  return setDoc(tableMetaRef, tableMetaData);
}

function updateLiveToFirestore(liveData){
  const firestoreDb = useFirebaseFirestore();
  let liveRef = firestoreDb.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.SYNC_DATA,FIRESTORE_COLLECTIONS.LIVE)  
  return setDoc(liveRef, liveData,{merge: true});
}

function resetNonce(){
  const firestoreDb = useFirebaseFirestore();
  let versionDataRef = firestoreDb.subCollectionDocIdRef(FIRESTORE_COLLECTIONS.SYNC_DATA,FIRESTORE_COLLECTIONS.VERSION_DATA)  
  return setDoc(versionDataRef, {nonce: 1}, {merge: true});
}

export default defineNuxtPlugin(({ $pinia }) => {
  $pinia.use(MyPiniaPlugin)
})
